import styled from "styled-components";
import { mobile } from "../responsiveM";

const Container = styled.div`
  height: 30px;
  background-color: #193c06;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  ${mobile({ fontSize: "10px" })}
`;

const Announcement = () => {
  return <Container>Super Deal! Free Delivery on Orders Over $70</Container>;
};

export default Announcement;
